<template>
<!-- BEGIN HEADER -->
<div class="page-header -i navbar navbar-fixed-top">
  <!-- BEGIN HEADER INNER -->
  <div class="page-header-inner">
    <!-- BEGIN LOGO -->
    <div class="page-logo">
      <a href="index.html">
      <img src="../../assets/kyelogo.png" alt="logo" class="logo-default" style="margin-top:0px;" width="130px;" />
      </a>
      <div class="menu-toggler sidebar-toggler hide">
      </div>
    </div>
    <!-- END LOGO -->
    <LopeHorizontalMenu></LopeHorizontalMenu>
    <!-- BEGIN RESPONSIVE MENU TOGGLER -->
    <a href="javascript:;" class="menu-toggler responsive-toggler" data-toggle="collapse" data-target=".navbar-collapse">
    </a>
    <!-- END RESPONSIVE MENU TOGGLER -->
    <!-- BEGIN TOP NAVIGATION MENU -->
    <div class="top-menu">
      <ul class="nav navbar-nav pull-right">
        <!-- BEGIN USER LOGIN DROPDOWN -->
        <!-- DOC: Apply "dropdown-dark" class after below "dropdown-extended" to change the dropdown styte -->
        <li class="dropdown dropdown-user">
          <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" data-hover="dropdown" data-close-others="true">
          <img alt="" class="img-circle" src="../../assets/admin.png"/>
          <span class="username username-hide-on-mobile">{{username}}</span>
          </a>
        </li>
        <!-- END USER LOGIN DROPDOWN -->
        <!-- BEGIN QUICK SIDEBAR TOGGLER -->
        <!-- DOC: Apply "dropdown-dark" class after below "dropdown-extended" to change the dropdown styte -->
        <li class="dropdown dropdown-quick-sidebar-toggler">
          <a href="javascript:;" @click="exit" class="dropdown-toggle">
          <i class="icon-logout"></i>
          </a>
        </li>
        <!-- END QUICK SIDEBAR TOGGLER -->
      </ul>
    </div>
    <!-- END TOP NAVIGATION MENU -->
  </div>
  <!-- END HEADER INNER -->
</div>
<!-- END HEADER -->
</template>
<script>
import {MSG_ID, K_LOGINED_USER} from '../../lib/constant'
import db from '../../store/local.js'
import LopeHorizontalMenu from './horizontalmenu'
export default {
  data () {
    return {
      user: db.get(K_LOGINED_USER)
    }
  },
  components: {
    LopeHorizontalMenu
  },
  computed: {
    username () {
      return this.user && this.user.account ? this.user.account.username : ''
    }
  },
  methods: {
    exit () {
      window.emitter.emit(MSG_ID.MSG_UI_CONFIRM, '退出系统', () => {
        window.emitter.emit(MSG_ID.MSG_SYS_EXIT)
      })
    }
  },
  mounted () {
    console.log(this.user.usr)
  }
}
</script>


// WEBPACK FOOTER //
// header.vue?534625ee